/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getMacrosRpc = {
  serviceName: 'com.hubspot.cv.macros.rpc.MacroRpc',
  rpcName: 'getMacros',
  auth: 'app',
  fingerprint: '30TEAX3LRjGhL6SD9pcse5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false
};
export const getMacroRpc = {
  serviceName: 'com.hubspot.cv.macros.rpc.MacroRpc',
  rpcName: 'getMacro',
  auth: 'app',
  fingerprint: '-5EYtpzgneUbEXUqt0tbgpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false
};
export const createRpc = {
  serviceName: 'com.hubspot.cv.macros.rpc.MacroRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'kkW83r5ylOXgc54DywS7tJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false
};
export const updateMacroRpc = {
  serviceName: 'com.hubspot.cv.macros.rpc.MacroRpc',
  rpcName: 'updateMacro',
  auth: 'app',
  fingerprint: '325JfnEsVdeOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false
};
export const deleteMacroRpc = {
  serviceName: 'com.hubspot.cv.macros.rpc.MacroRpc',
  rpcName: 'deleteMacro',
  auth: 'app',
  fingerprint: 'i1HVKkt56MuOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false
};
export const hardDeleteMacroRpc = {
  serviceName: 'com.hubspot.cv.macros.rpc.MacroRpc',
  rpcName: 'hardDeleteMacro',
  auth: 'app',
  fingerprint: 'yeHE25LxvJmOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false
};
export const runMacroRpc = {
  serviceName: 'com.hubspot.cv.macros.rpc.MacroRpc',
  rpcName: 'runMacro',
  auth: 'app',
  fingerprint: 'g3zzRbAw5eaOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false
};